<template>
  <div>
    <el-icon><Loading /></el-icon>
  </div>
</template>
<script>
import {
  defineComponent,
  reactive,
  ref,
  toRefs,
  getCurrentInstance,
  onMounted,
  watch,
  computed,
} from "vue";
import { useRouter } from "vue-router";
import apis from "./index";
export default defineComponent({
  setup() {
    const { proxy } = getCurrentInstance();
    const router = useRouter();

    const state = reactive({
      search: [
        {
          component: "sTreeSelect",
          label: "所属组织",
          placeholder: "所属组织",
          value: "workClassifyId",
          defaultValue: 1,
          url: "treeSelectByUserApi",
          field: {
            id: "value",
            label: "label",
          },
        },
        {
          component: "sSelect",
          label: "设备分类",
          placeholder: "设备分类",
          value: "abcId",
          options: [
            { label: "全部", value: "" },
            { label: "A类", value: "1" },
            { label: "B类", value: "2" },
            { label: "C类", value: "3" },
          ],
        },
        {
          component: "sSelect",
          label: "设备状态",
          placeholder: "设备状态",
          value: "statusId",
          options: [
            { label: "全部", value: "" },
            { label: "正常", value: "1" },
            { label: "维修", value: "2" },
            { label: "保养", value: "3" },
          ],
        },
      ],
      moreSearch: [
        {
          component: "sSelect",
          label: "资产状态",
          placeholder: "资产状态",
          value: "assetStatusId",
          options: [
            { label: "全部", value: "" },
            { label: "启用", value: "1" },
            { label: "封存", value: "2" },
            { label: "报废", value: "3" },
          ],
        },
      ],
      api: {
        list: "getDeviceList",
        delete: "deleteDeviceApi",
        deleteAll: "",
        add: null,
        edit: null,
        detail: null,
        path: "/indexDetail", //详情页面路由
      },
      columns: [
        {
          prop: "name",
          label: "设备名称",
          width: "300",
        },
        {
          prop: "categoryIdText",
          label: "设备类型",
          width: "115",
        },
        {
          prop: "model",
          label: "型号",
          width: "80",
          scopeFun: (scope) => {
            return scope.row.model ? scope.row.model : "--";
          },
        },
        {
          prop: "deptIdText",
          label: "所属组织",
        },
        {
          prop: "abcText",
          label: "ABC类",
          width: "80",
        },
        {
          prop: "areaIdText",
          label: "区域位置",
          width: "115",
        },
        {
          prop: "assetStatusText",
          label: "资产状态",
          width: "100",
        },
        {
          prop: "statusText",
          label: "设备状态",
          width: "100",
          scopeComponent: "runningStatus",
        },
        {
          prop: "score",
          label: "设备健康度",
          scopeFun: (scope) => {
            return scope.row.score ? scope.row.score : "--";
          },
        },
      ],
    });
    onMounted(() => {});
    const goWorkbench = () => {};
    return {
      ...toRefs(state),
    };
  },
});
</script>

<style lang="less" scoped>
.workbench-container {
  width: 100%;
  height: 100%;
  background: #f5f5f5;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  padding: 16px;
  position: relative;
  .workbench-set {
    position: absolute;
    top: 0;
    right: 0;
    width: 40px;
    height: 40px;
    border-radius: 0 0 50% 50%;
    background: white;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
  }
  .workbench-draggable {
    width: 100%;
    .workbench-empty {
      width: 100%;
      height: 800px;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .draggable-list {
      display: flex;
      flex-wrap: wrap;
      box-sizing: border-box;
      justify-content: space-between;
    }
  }
}
.item {
  text-align: left;
  margin-bottom: 16px;
  height: 450px;
  background-color: white;
  border-radius: 8px 8px 8px 8px;
  position: relative;
  // overflow: hidden;
  &.flex1 {
    width: calc((100% - 32px) / 3);
  }
  &.flex2 {
    width: calc(((100% - 32px) / 3) * 2 + 16px);
  }
  &.flex3 {
    width: 100%;
  }
  &:hover {
    .item-size {
      display: flex;
    }
  }
  .item-size {
    position: absolute;
    top: -1px;
    right: 20px;
    width: 50%;
    height: 55px;
    background-color: white;
    display: none;
    align-items: center;
    justify-content: flex-end;
    z-index: 99;
    > div {
      width: 20px;
      margin-right: 5px;
      cursor: pointer;
      text-align: center;
      border-radius: 2px;
    }
  }
  //   .item-name {
  //     height: 55px;
  //     border-bottom: 1px solid #F5F5F5;
  //   }
  //   .item-content {
  //     height: calc(100% - 56px);
  //   }
}

.ghost {
  border: solid 1px rgb(19, 41, 239);
}
.chosenClass {
  background-color: #f1f1f1;
}
</style>
